/**
 * Browser tab titles: "Page - Commune", with the commune's name taken from
 * the site settings rather than from the build-time app name.
 */

export function siteNameFrom(
    props: Record<string, unknown>,
    fallback: string,
): string {
    const settings = props.siteSettings as
        | { business_name?: string | null }
        | undefined;

    return settings?.business_name?.trim() || fallback;
}

export function pageTitle(title: string, siteName: string): string {
    // The home page is titled with the commune's name already.
    return title && title !== siteName ? `${title} - ${siteName}` : siteName;
}
